var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.noForms
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.buscarButton,
                expression: "buscarButton"
              }
            ],
            staticClass: "card"
          },
          [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "form",
                {
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "row mb-0" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.createButton,
                            expression: "createButton"
                          }
                        ],
                        staticClass: "col-xs-12"
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn-success btn--bigger",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.currentIndex = -1
                                _vm.crear()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-external-link" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("message.crear")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.exportable,
                                expression: "exportable"
                              }
                            ],
                            staticClass: "btn-info",
                            attrs: { type: "button" },
                            on: { click: _vm.exportar }
                          },
                          [
                            _c("i", { staticClass: "fa fa-print" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("message.exportar")))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 my-2" }, [
                      _c("div", { staticClass: "form-inline" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filterStatus,
                                expression: "filterStatus"
                              }
                            ],
                            staticClass: "form-inline row mb-0 mt-3"
                          },
                          [
                            _c("div", { staticClass: "col-xs-12 col-lg-2" }, [
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.filterStatus,
                                      expression: "filterStatus"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(_vm.$t("message.estado")))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-12 col-lg-10" }, [
                              _c("label", [
                                _c(
                                  "label",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.filterStatus,
                                        expression: "filterStatus"
                                      }
                                    ]
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.status,
                                          expression: "form.status"
                                        }
                                      ],
                                      attrs: { type: "radio", value: "A" },
                                      domProps: {
                                        checked: _vm._q(_vm.form.status, "A")
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            return _vm.$set(
                                              _vm.form,
                                              "status",
                                              "A"
                                            )
                                          },
                                          _vm.submit
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("message.activos")))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("label", [
                                _c(
                                  "label",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.filterStatus,
                                        expression: "filterStatus"
                                      }
                                    ]
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.form.status,
                                          expression: "form.status"
                                        }
                                      ],
                                      attrs: { type: "radio", value: "I" },
                                      domProps: {
                                        checked: _vm._q(_vm.form.status, "I")
                                      },
                                      on: {
                                        change: [
                                          function($event) {
                                            return _vm.$set(
                                              _vm.form,
                                              "status",
                                              "I"
                                            )
                                          },
                                          _vm.submit
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.inactivos"))
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.esComprobante,
                                      expression: "!esComprobante"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.filterStatus,
                                          expression: "filterStatus"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.form.status,
                                            expression: "form.status"
                                          }
                                        ],
                                        attrs: { type: "radio", value: "T" },
                                        domProps: {
                                          checked: _vm._q(_vm.form.status, "T")
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              return _vm.$set(
                                                _vm.form,
                                                "status",
                                                "T"
                                              )
                                            },
                                            _vm.submit
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("message.todos")))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.fechas,
                            expression: "fechas"
                          }
                        ],
                        staticClass: "col-xs-12"
                      },
                      [
                        _c("div", { staticClass: "form-inline row mb-0" }, [
                          _c("div", { staticClass: "col-xs-12 col-lg-1" }, [
                            _c("label", [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.$t("message.fecha")))
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12 col-lg-11" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.tipo_fecha,
                                    expression: "form.tipo_fecha"
                                  }
                                ],
                                attrs: { type: "radio", value: "H" },
                                domProps: {
                                  checked: _vm._q(_vm.form.tipo_fecha, "H")
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "tipo_fecha",
                                        "H"
                                      )
                                    },
                                    _vm.submit
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.hoy")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.tipo_fecha,
                                    expression: "form.tipo_fecha"
                                  }
                                ],
                                attrs: { type: "radio", value: "A" },
                                domProps: {
                                  checked: _vm._q(_vm.form.tipo_fecha, "A")
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "tipo_fecha",
                                        "A"
                                      )
                                    },
                                    _vm.submit
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.ayer")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.tipo_fecha,
                                    expression: "form.tipo_fecha"
                                  }
                                ],
                                attrs: { type: "radio", value: "P" },
                                domProps: {
                                  checked: _vm._q(_vm.form.tipo_fecha, "P")
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(_vm.form, "tipo_fecha", "P")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("message.personalizada")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.form.tipo_fecha === "P" ||
                                      (_vm.fechas &&
                                        _vm.form.tipo_fecha === "P"),
                                    expression:
                                      "((form.tipo_fecha === 'P')||(fechas && form.tipo_fecha ==='P'))"
                                  }
                                ],
                                staticClass: "form-field"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "datepicker-field datepicker-field--stretch"
                                  },
                                  [
                                    _c("date-picker", {
                                      attrs: {
                                        type: "date",
                                        format: "dd-MM-yyyy",
                                        id: "desde",
                                        lang: "es"
                                      },
                                      model: {
                                        value: _vm.form.fecha_desde,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "fecha_desde", $$v)
                                        },
                                        expression: "form.fecha_desde"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.desde")))
                                    ]),
                                    _vm._v(" "),
                                    _vm.errores.fecha_desde
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "helper-text text-danger",
                                            attrs: { slot: "helper" },
                                            slot: "helper"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errores.fecha_desde[0]
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.form.tipo_fecha === "P" ||
                                      (_vm.fechas &&
                                        _vm.form.tipo_fecha === "P"),
                                    expression:
                                      "((form.tipo_fecha === 'P')||(fechas && form.tipo_fecha ==='P'))"
                                  }
                                ],
                                staticClass: "form-field"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "datepicker-field datepicker-field--stretch"
                                  },
                                  [
                                    _c("date-picker", {
                                      attrs: {
                                        type: "date",
                                        format: "dd-MM-yyyy",
                                        id: "hasta",
                                        lang: "es"
                                      },
                                      model: {
                                        value: _vm.form.fecha_hasta,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "fecha_hasta", $$v)
                                        },
                                        expression: "form.fecha_hasta"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("message.hasta")))
                                    ]),
                                    _vm._v(" "),
                                    _vm.errores.fecha_hasta
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "helper-text text-danger",
                                            attrs: { slot: "helper" },
                                            slot: "helper"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.errores.fecha_hasta[0]
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12",
                        class: {
                          "col-md-9": _vm.verTipoComprobante,
                          "col-md-10": _vm.esComprobanteContable
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.buscarButton,
                                expression: "buscarButton"
                              }
                            ],
                            staticClass: "form-group"
                          },
                          [
                            _c("input-field", {
                              attrs: {
                                stretch: "",
                                id: "buscar",
                                placeholder: _vm.$t("message.consulta")
                              },
                              on: { keyup: _vm.keyup },
                              model: {
                                value: _vm.form.search,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "search", $$v)
                                },
                                expression: "form.search"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-info btn--bigger",
                                attrs: { type: "submit" }
                              },
                              [
                                _c("i", { staticClass: "fa fa-search" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("message.buscar")))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "form-inline mb-3" }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("message.registrosPorPagina")))]),
          _vm._v(" "),
          _c("div", { staticClass: "ktable-select" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.cantidadRegistros,
                    expression: "form.cantidadRegistros"
                  }
                ],
                attrs: { id: "cantidadRegistros" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "cantidadRegistros",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.submit
                  ]
                }
              },
              [
                _c("option", { domProps: { value: 10 } }, [_vm._v("10")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 30 } }, [_vm._v("30")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 50 } }, [_vm._v("50")]),
                _vm._v(" "),
                _c("option", { domProps: { value: 100 } }, [_vm._v("100")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "table-selectable", class: _vm.classes }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.columns, function(column, index) {
                    return _c(
                      "th",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !column.hidden,
                            expression: "!column.hidden"
                          }
                        ],
                        key: "column" + index
                      },
                      [_vm._v(_vm._s(column.display))]
                    )
                  }),
                  _vm._v(" "),
                  _c("th", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editButton ||
                          _vm.deleteButton ||
                          _vm.buttons.length > 0,
                        expression:
                          "(editButton || deleteButton || buttons.length > 0)"
                      }
                    ]
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.rows, function(row, index) {
                  return _c(
                    "tr",
                    {
                      key: "row" + index,
                      class: {
                        "tr--pending":
                          _vm.esComprobante &&
                          row.id_estado_comprobante === "PPR" &&
                          row.anulado === "N",
                        "tr--issued":
                          _vm.esComprobante &&
                          row.id_estado_comprobante === null &&
                          row.anulado === "N",
                        "tr--canceled":
                          (_vm.esComprobante && row.anulado === "S") ||
                          (!_vm.esComprobante && row.estado === "I") ||
                          row.enviado === "N",
                        "tr--authorized":
                          (_vm.esComprobante &&
                            row.id_estado_comprobante === "AUT") ||
                          (!_vm.esComprobante && row.estado === "A") ||
                          row.enviado === "S"
                      },
                      on: {
                        dblclick: function($event) {
                          _vm.currentIndex = index
                          _vm.seleccionar(row)
                        }
                      }
                    },
                    [
                      _vm._l(_vm.columns, function(column, ix) {
                        return _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !column.hidden,
                                expression: "!column.hidden"
                              }
                            ],
                            key: "cell" + index + ix
                          },
                          [
                            column.input &&
                            column.type !== "checkbox" &&
                            column.type !== "radio"
                              ? _c("input-field", {
                                  attrs: {
                                    id: "cell" + index + ix,
                                    type: column.type
                                  },
                                  on: {
                                    keyup: function($event) {
                                      return _vm.emitirInputs(_vm.rows)
                                    }
                                  },
                                  model: {
                                    value: row[column.value],
                                    callback: function($$v) {
                                      _vm.$set(row, column.value, $$v)
                                    },
                                    expression: "row[column.value]"
                                  }
                                })
                              : column.input
                              ? _c(
                                  "label",
                                  { attrs: { for: "cell" + index + ix } },
                                  [
                                    column.type === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row[column.value],
                                              expression: "row[column.value]"
                                            }
                                          ],
                                          attrs: {
                                            id: "cell" + index + ix,
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              row[column.value]
                                            )
                                              ? _vm._i(
                                                  row[column.value],
                                                  null
                                                ) > -1
                                              : row[column.value]
                                          },
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$a = row[column.value],
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        row,
                                                        column.value,
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        row,
                                                        column.value,
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    row,
                                                    column.value,
                                                    $$c
                                                  )
                                                }
                                              },
                                              function($event) {
                                                return _vm.emitirInputs(
                                                  _vm.rows
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      : column.type === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row[column.value],
                                              expression: "row[column.value]"
                                            }
                                          ],
                                          attrs: {
                                            id: "cell" + index + ix,
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              row[column.value],
                                              null
                                            )
                                          },
                                          on: {
                                            change: [
                                              function($event) {
                                                return _vm.$set(
                                                  row,
                                                  column.value,
                                                  null
                                                )
                                              },
                                              function($event) {
                                                return _vm.emitirInputs(
                                                  _vm.rows
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: row[column.value],
                                              expression: "row[column.value]"
                                            }
                                          ],
                                          attrs: {
                                            id: "cell" + index + ix,
                                            type: column.type
                                          },
                                          domProps: {
                                            value: row[column.value]
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.emitirInputs(_vm.rows)
                                            },
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                row,
                                                column.value,
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("span")
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !column.input,
                                        expression: "!column.input"
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          column.prefijo != undefined ? "$" : ""
                                        ) +
                                        _vm._s(
                                          column.numeric
                                            ? parseFloat(
                                                row[column.value]
                                              ).toLocaleString(_vm.locale)
                                            : row[column.value]
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.editButton ||
                                _vm.deleteButton ||
                                _vm.buttons.length > 0,
                              expression:
                                "(editButton || deleteButton || buttons.length > 0)"
                            }
                          ],
                          staticClass: "table-actions"
                        },
                        [
                          _vm.editButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn-info btn--text",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.currentIndex = index
                                      _vm.editar(row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-edit" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.deleteButton
                            ? _c(
                                "button",
                                {
                                  class: {
                                    "btn-danger btn--text":
                                      row.estado == "A" ||
                                      (row.estado == null &&
                                        !_vm.esNotaDeDebito) ||
                                      row.estado == 1 ||
                                      (_vm.esNotaDeDebito && row.estado == "E"),
                                    "btn-success btn--text":
                                      row.estado == "I" || row.estado == 0
                                  },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.currentIndex = index
                                      _vm.eliminar(row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash-o" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.buttons, function(button, index) {
                            return _c(
                              "button",
                              {
                                key: index,
                                staticClass: "btn--text",
                                class: button.class,
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit(button.event, row)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class: button.icon
                                }),
                                _vm._v(" "),
                                button.text !== ""
                                  ? _c("span", [_vm._v(_vm._s(button.text))])
                                  : _vm._e()
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.rows.length === 0,
                        expression: "rows.length === 0"
                      }
                    ]
                  },
                  [
                    _c(
                      "td",
                      {
                        attrs: {
                          colspan:
                            _vm.columns.length +
                            (_vm.editButton || _vm.deleteButton ? 1 : 0)
                        }
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("message.sinDatos")))
                        ])
                      ]
                    )
                  ]
                )
              ],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ktable-pagination" }, [
          _c(
            "p",
            {
              staticClass: "ktable-pagination__button",
              attrs: {
                disabled: _vm.form.currentPage == 0 || _vm.form.currentPage == 1
              }
            },
            [
              _c(
                "a",
                { attrs: { href: "#" }, on: { click: _vm.anteriorPagina } },
                [
                  _c("i", { staticClass: "fa fa-chevron-left" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.anterior")))])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "ktable-pagination__button",
              attrs: {
                disabled:
                  _vm.form.currentPage == _vm.totalPages || _vm.totalPages == 1
              }
            },
            [
              _c(
                "a",
                { attrs: { href: "#" }, on: { click: _vm.siguientePagina } },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("message.siguiente")))]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-chevron-right" })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.paginas")))]),
          _vm._v(" "),
          _c("div", { staticClass: "ktable-select" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.currentPage,
                    expression: "form.currentPage"
                  }
                ],
                attrs: { id: "paginaActual" },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "currentPage",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                    _vm.submit
                  ]
                }
              },
              [
                _c(
                  "option",
                  { attrs: { disabled: "" }, domProps: { value: 0 } },
                  [_vm._v("...")]
                ),
                _vm._v(" "),
                _vm._l(_vm.totalPages, function(i) {
                  return _c(
                    "option",
                    { key: "pages" + i, domProps: { value: i } },
                    [_vm._v(_vm._s(i))]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(_vm._s(_vm.$t("message.de")) + " " + _vm._s(_vm.totalPages))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Registros totales: " +
                _vm._s(_vm.registrosHastaPagina) +
                " - " +
                _vm._s(_vm.registrosTotales)
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e86a0e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e86a0e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/KTable.vue
// module id = 264
// module chunks = 0